import { axios } from '@Root/API'

export const previewFieldMappings = params => {
  return axios.get('cognito-form-field-mappings/preview', { params })
}
